import { sortDates } from 'src/utils/dates/sortDates';
import { CongestionReportsResponse } from '../hooks/useCongestionReports';

export const getLatestCompletionDate = (reports: CongestionReportsResponse[] | undefined) => {
  if (!reports?.length) return undefined;

  const completionDates = reports
    .map((report) => report.completionDate)
    .filter((date) => typeof date === 'string');

  const sortedCompletionDates = sortDates(completionDates);

  return sortedCompletionDates[0] ?? undefined;
};
